import React, { Fragment } from 'react';
import styled from 'styled-components';
import { color, border, variant } from 'styled-system';
import PropTypes from 'prop-types';

const EmptyPlaceholder = styled.div`
  border-width: 1px;
  ${color};
  ${border};
  width: 188px;
  height: 233px;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 23px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  margin-right: 16px;

  ${variant({
    variants: {
      withPlaceholder: {
        borderStyle: 'dashed',
        borderColor: 'black.40',
      },
      withoutPlaceholder: {
        borderStyle: 'solid',
        borderColor: 'black.10',
      },
    },
  })}
`;

const unscheduledPlanDate = '0000-00-00';

const PlaceholderContent = () => <Fragment>Drag Tile Here</Fragment>;

const EmptyDigestPlaceholder = props => {
  const plannedDatePlaceholder = props.columnId
    ? !props.columnId.includes(unscheduledPlanDate)
    : true;
  const firstRow = props.columnNumber === 0;

  const variantPlaceholder =
    plannedDatePlaceholder && firstRow
      ? 'withPlaceholder'
      : 'withoutPlaceholder';

  return (
    <EmptyPlaceholder
      bg="black.5"
      color="black.60"
      variant={variantPlaceholder}
    >
      {plannedDatePlaceholder && firstRow && <PlaceholderContent />}
    </EmptyPlaceholder>
  );
};

EmptyDigestPlaceholder.propTypes = {
  columnId: PropTypes.string,
  columnNumber: PropTypes.number,
};

export { EmptyDigestPlaceholder };
